exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".steetsnap-product-container {\n  width: 1028px;\n  margin: 0 auto;\n  padding: 24px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/features/streetSnap/streetInfluencer/component/index.less
// module id = 1262
// module chunks = 0